import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { baseUrl } from '..';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [hostelIds, setHostelIds] = useState([]);
    const [hostels, setHostels] = useState([]);
    const [role, setRole] = useState('');
    const [loading, setLoading] = useState(true);
    const [selectedHostelId, setSelectedHostelId] = useState(localStorage.getItem("selectedHostel") || "");
let selectedHostelData = hostels.find(
  (hostel) => hostel.id === Number(selectedHostelId)  
)



    const fetchUser = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${baseUrl}/hostel/owner-hostels`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });
            console.log(res.data)
            setHostelIds(res.data.hostelIds || []);
            setRole(res.data.role || '');
            setHostels(res.data.hostels)
            // If only one hostel, auto-select it
            if ((res.data.hostelIds || []).length === 1) {
                setSelectedHostelId(res.data.hostelIds[0]);
                localStorage.setItem("selectedHostel", res.data.hostelIds[0]);
            }
        } catch (error) {
            setHostelIds([]);
            setRole('');
            setHostels([]);
            setSelectedHostelId("");
            console.error("Error fetching hostels:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUser();
    }, []);

    // Keep localStorage in sync
    useEffect(() => {
        if (selectedHostelId) {
            localStorage.setItem("selectedHostel", selectedHostelId);
        }
    }, [selectedHostelId]);

    return (
        <UserContext.Provider value={{
            hostelIds,
            hostels,
            role,
            loading,
            fetchUser,
            selectedHostelId,
            setSelectedHostelId,
            selectedHostelData
        }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);